import RoutesMap from "../../route_control/RouteControl"
import {
    AddUser,
    UserList,
    UpdateUser
} from "../../pages/user_management"

export const UserManagementRouteImport = {
    RoutesMap,
    AddUser,
    UserList,
    UpdateUser,
}

